"use client";

interface HowToReach {
  Title: string;
  Description: string;
}

interface HowToReachSectionProps {
  howToReach: HowToReach[];
}

export default function HowToReachSection({
  howToReach,
}: HowToReachSectionProps) {
  if (!howToReach || howToReach.length === 0) return null;

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl mb-8 text-[#1A1A1A]">
            How to Reach
          </h2>
          <div className="w-24 h-1 bg-[#C9A962] mb-12"></div>

          <div className="relative">
            {/* Vertical Line */}
            <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-[#B42025] via-[#C9A962] to-transparent hidden md:block" />

            {howToReach.map((reach, index) => (
              <div key={index} className="relative mb-12 last:mb-0">
                <div className="flex items-start gap-6 flex-col sm:flex-row">
                  {/* Step Number */}
                  <div className="relative flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-br from-[#B42025] to-[#C9A962] rounded-full flex items-center justify-center">
                      <span className="text-white text-xl font-bold">
                        {index + 1}
                      </span>
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-1 bg-[#F9F7F4] rounded-2xl p-4 border border-gray-200 w-full">
                    <h3 className="text-xl font-medium text-[#1A1A1A] mb-4">
                      {reach.Title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {reach.Description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
